// extracted by mini-css-extract-plugin
export default {"ant-page-header":"styles_ant-page-header__lRhF5","ant-page-header-heading-title":"styles_ant-page-header-heading-title__EjkK6","table":"styles_table__0tdyk"};